import { NgModule } from "@angular/core";
import { ModalComponent } from "./components/modal.component";
import { ModalDirective } from "./directives/modal.directive";
import { ModalService } from "./services/modal.service";
import { SharedModule } from "../shared/shared.module";
import { ProfileModule } from "../profile/profile.module";
import { CommonModule } from "@angular/common";
@NgModule({
  declarations: [ModalComponent, ModalDirective],
  imports: [ProfileModule, SharedModule, CommonModule],
  exports: [ModalComponent],
  providers: [ModalService],
})
export class ModalModule {}
